import 'angular:locale/data:pt-BR';
import 'zone.js';(globalThis.$localize ??= {}).locale = "pt-BR";
